"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _2xkoIconPack = {
    prefix: '2xko_',
    cdnSuffix: '2xko',
    version: 'latest',
    icons: {
        H: 'H.svg',
        L: 'L.svg',
        M: 'M.svg',
        R3: 'R3.svg',
        S1: 'S1.svg',
        S2: 'S2.svg',
        T: 'T.svg',
        back: 'back.svg',
        back_back: 'back_back.svg',
        down: 'down.svg',
        down_back: 'down_back.svg',
        down_down: 'down_down.svg',
        down_forward: 'down_forward.svg',
        forward: 'forward.svg',
        forward_forward: 'forward_forward.svg',
        or: 'or.svg',
        plus: 'plus.svg',
        round_bracket_close: 'round_bracket_close.svg',
        round_bracket_open: 'round_bracket_open.svg',
        square_bracket_close: 'square_bracket_close.svg',
        square_bracket_open: 'square_bracket_open.svg',
        sub_line: 'sub_line.svg',
        up: 'up.svg',
        up_back: 'up_back.svg',
        up_forward: 'up_forward.svg',
        up_up: 'up_up.svg',
    },
};
exports.default = _2xkoIconPack;
